/**
 * haptic.js — tiny native-feel touch feedback.
 *
 * navigator.vibrate is widely supported on Android Chrome / Samsung
 * Internet / Edge on Android. Silently no-ops on iOS Safari (which
 * blocks vibrate for unauthenticated origins) and desktop. That's
 * exactly the behavior we want: enhancement-only, never breakage.
 *
 * Three tap weights — pick the one closest to the gesture's "feel":
 *   tick()   — ~8ms. List item select, deck advance, dot rail.
 *   tap()    — ~18ms. Primary CTA, share confirmation.
 *   double() — two short pulses. Important state change (success).
 */
function _safeVibrate(pattern) {
    try {
        if (typeof navigator !== "undefined" && typeof navigator.vibrate === "function") {
            navigator.vibrate(pattern);
        }
    } catch {
        // Some browsers throw on permission-suspended documents — ignore.
    }
}

export const tick = () => _safeVibrate(8);
export const tap = () => _safeVibrate(18);
export const double = () => _safeVibrate([12, 60, 12]);
